import { Component } from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { AlertCircleIcon } from '@hugeicons/core-free-icons'
import type { ReactNode } from 'react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

interface Props {
  children: ReactNode
  onReset?: () => void
}

interface State {
  hasError: boolean
  error?: Error
}

export class SurveyErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(_error: Error, _errorInfo: unknown) {
    // Error captured by getDerivedStateFromError — Sentry reports in production
  }

  handleReset = () => {
    this.setState({ hasError: false, error: undefined })
    this.props.onReset?.()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="max-w-4xl mx-auto p-4">
          <Alert variant="destructive">
            <HugeiconsIcon icon={AlertCircleIcon} className="h-4 w-4" />
            <AlertTitle>Survey Error</AlertTitle>
            <AlertDescription className="mt-2">
              {this.state.error?.message ||
                'Something went wrong with the survey'}
            </AlertDescription>
            <Button
              onClick={this.handleReset}
              variant="outline"
              className="mt-4"
              size="sm"
            >
              Try Again
            </Button>
          </Alert>
        </div>
      )
    }

    return this.props.children
  }
}
